Ext.namespace('utils.form.render');

utils.form.render = (function( $, Ext, window, undefined ){
    var public = new Object(), scope = null, el;
	
	public = {
		scope: null
	};
	
    public.setScope = function(_this){
		scope = _this;
    };
		
    public.setElements = function(_el){
		el = _el;
    };
	
	public.init = function(){
		var form = new Ext.form.BasicForm('form');
		
		Ext.QuickTips.init();
		Ext.form.Field.prototype.msgTarget = 'qtip';
		Ext.form.Field.prototype.markInvalid = function(msg){
			if(!this.rendered || this.preventMark){ 
				return;
			}
			msg = msg || this.invalidText;
	
			var mt = this.getMessageHandler();

			if(mt){
				mt.mark(this, msg);
			}else if(this.msgTarget){
				this.el.addClass(this.invalidClass);
				var t = Ext.getDom(this.msgTarget);
				if(t){
					t.innerHTML = msg;	
					t.style.display = 'block';
				}
			}
		
			
			this.fireEvent('invalid', this, msg);
		}

		return form;
	};
	
	public.tableOddAddCss = function(){
		$('.other-area>tbody>tr').removeClass('odd');
		$('.other-area>tbody>tr:visible').each(function (i) {
			if (i % 2 == 0) $(this).addClass('odd');
		});
	}
	
    public.run = function(items){
		if(!$.isArray(items)) 
			items = ['button', 'text', 'textarea', 'file', 'select', 'number', 'date', 'phone'];
			
		for(var x in items)
		{
			var fun = this[items[x]];
			
			if(typeof fun === 'function') fun();
		}
	};
	
    public.button = function(){
		el.find('input[type="submit"], input[type="button"], input[type="reset"]').each(function(){
			var config = new Object, button, type = $(this).attr('type');
			var s = $(this).attr('onclick');
			var eventFuns = scope.utils.form.event();

			config.applyTo = $(this).get(0);
			config.width = $(this).width();
			config.handler = eval($(this).attr('onclick'));
			config.text = $(this).val();
			
			switch (type)
			{
				case 'submit':	
					if(config.text == '') config.text = utils.icon('check-square', '　儲　存');
					if(typeof config.handler == 'undefined')
					{
						config.handler = eventFuns.onSave;
						config.id = 'button-save';
					}
				break;
				
				case 'reset':	
					if(config.text == '') config.text = utils.icon('retweet', '　重　填');
					if(typeof config.handler == 'undefined') config.handler = eventFuns.onReset;
				break;
			}

			button = (new Ext.Button(config));  		
			button.getEl().replace($(this).get(0));     
		});
	};

    public.text = function(){
		el.find('input[type="text"], input[type=password]').each(function(){
			var config = {}, type = $(this).attr('type');
			
			config = utils.config.form.required($(this));
			
			config.applyTo = $(this).get(0);
			config.width = $(this).attr('data-width') ? $(this).attr('data-width') : $(this).width();
			
			if($(this).attr('vtype')) config.vtype = $(this).attr('vtype');
			if($(this).attr('check')) config.check = $(this).attr('check');
			if($(this).attr('min')) config.minLength = $(this).attr('min');
			if($(this).attr('max')) config.maxLength = $(this).attr('max');
						
			scope.window.form.add(new Ext.form.TextField(config));  			
		});
	};

    public.textarea = function(){
		el.find('textarea').each(function(){
			switch ($(this).attr('ext-type'))
			{
				case 'ckeditor' :
					$(this).ckeditor({
						skin : 'office2013',
						width: $(this).width(),
						height : $(this).height(),
						font_names : '細明體;新細明體;標楷體;Arial;Comic Sans MS;Courier New;Tahoma;Times New Roman;Verdana',  
						toolbar :  
						[

							['Cut','Copy','Paste','PasteText','PasteFromWord','-'],
							['Undo','Redo','-','RemoveFormat','ShowBlocks'],
							['Link','Unlink','Anchor'],
							['Image','Flash','Table','HorizontalRule','SpecialChar'],
							'/',
							['Bold','Italic','Underline','Strike','-','Subscript','Superscript'],
							['NumberedList','BulletedList','-','Outdent','Indent'],
							['JustifyLeft','JustifyCenter','JustifyRight','JustifyBlock'],
							['TextColor','BGColor'],
							['FontSize','Font'],
							['Maximize','-'],
							['Source']
						],  
						allowedContent : true,
						enterMode : CKEDITOR.ENTER_BR,
						shiftEnterMode : CKEDITOR.ENTER_P,
						contentsCss : $(this).attr('data-css'),
						filebrowserBrowseUrl : app.ckfinder + '/ckfinder.html',
						filebrowserImageBrowseUrl : app.ckfinder + '/ckfinder.html?Type=Images',
						filebrowserImageUploadUrl : app.ckfinder + '/core/connector/php/connector.php?command=QuickUpload&type=Images'
					});
				break;
				
				default :
					var config = new Object;
					
					config = utils.config.form.required($(this));
					
					config.applyTo = $(this).get(0);
					config.width = $(this).data('width') ? $(this).data('width') : $(this).width();
					config.height = $(this).height();
					
					scope.window.form.add(new Ext.form.TextArea(config));  
			}
		});
	};

    public.file = function(){
		el.find('div[ext-type="file"]').each(function(){
			var config = new Object, input;
			
			config = utils.config.form.required($(this));
			
			config.renderTo = $(this).get(0);
			config.width = $(this).width();
			config.name = $(this).attr('name');
			config.buttonOnly = eval($(this).attr('buttonOnly'));
			config.buttonText = utils.icon('file-image-o', '上傳');
						
			input = new Ext.ux.form.FileUploadField(config); 

			scope.window.form.add(input);		
		});
	};

    public.select = function(){
		el.find('select').each(function(){
			var config = new Object;
			
			config = utils.config.form.required($(this));
			
			config.transform = $(this).get(0);
			config.width = $(this).width();
			config.id = $(this).attr('id');
			config.editable = false;
			config.triggerAction = 'all';

			if($(this).attr('onchange')) {
				config.listeners = {
					select: window[$(this).attr('onchange')]
				}
			}

			scope.window.form.add(new Ext.form.ComboBox(config));  			
		});
	};

    public.number = function(){
		el.find('input[ext-type="number"]').each(function(){
			var config = new Object, input;
			
			config = utils.config.form.required($(this));
			
			config.applyTo = $(this).get(0);
			config.width = $(this).attr('data-width') ? $(this).attr('data-width') : $(this).width();
			
			if($(this).attr('min')) config.minValue = $(this).attr('min');
            if($(this).attr('max')) config.maxValue = $(this).attr('max');
            if($(this).attr('increment')) config.incrementValue = $(this).attr('increment');
			
			input = new Ext.ux.form.SpinnerField(config);
						
			scope.window.form.add(input);  			
		});
	};

	public.phone = function(){
		el.find('input[ext-type="phone"]').each(function(){
			$(this).intlTelInput({
				//onlyCountries: ['cn', 'tw'],
				defaultCountry: "auto",
				geoIpLookup: function(callback) {
					$.get('http://ipinfo.io', function() {}, "jsonp").always(function(resp) {
						var countryCode = (resp && resp.country) ? resp.country : "";
						callback(countryCode);
					});
				},
				//utilsScript: "../vendor/jquery/plugins/tel/utils.js"
			});
		});
	};

    public.date = function(){
		el.find('input[ext-type="date"]').each(function(){
			var config = new Object, input;
			var attr = ['vtype', 'id', 'endDateField', 'startDateField'];
			config = utils.config.form.required($(this));
			
			config.applyTo = $(this).get(0);
			config.width = $(this).width();
			config.format = 'Y-m-d';
			config.readOnly = true;
			
			for(var x = 0; x < attr.length; x++)
			{
				if($(this).attr(attr[x])) config[attr[x]] = $(this).attr(attr[x]);				
			}
			
			input = new Ext.form.DateField(config);
						
			scope.window.form.add(input);  			
		});
	}
	
    return public;
}( jQuery, Ext, window ));


